import JourneyInfo from './JourneyInfo';

export default JourneyInfo;
